import React from "react";
import { DEFAULT_TITLE, VARIANT_MODE_OPTIONS } from "./constants";

const selectClass =
  "w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500";

/**
 * Settings modal content for the ABC/XYZ panel.
 *
 * Holds the tile title and the Variant Analysis configuration (object type,
 * variant grouping mode). The Object Analysis configuration lives inline in
 * the tile, not here.
 */
const ABCXYZAnalysisSettings = ({
  title,
  objectTypes,
  variantObjectType,
  variantMode,
  onTitleChange,
  onVariantObjectTypeChange,
  onVariantModeChange,
  loading = false,
}) => (
  <div className="space-y-6">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Title
      </label>
      <input
        type="text"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        placeholder={DEFAULT_TITLE}
        disabled={loading}
      />
    </div>

    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">
      <label className="block text-sm font-medium text-gray-700">
        Variant Matrix
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Object Type *
          </label>
          <select
            value={variantObjectType}
            onChange={(e) => onVariantObjectTypeChange(e.target.value)}
            className={selectClass}
            disabled={loading}
          >
            <option value="">Select Object Type</option>
            {(objectTypes || []).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Variant Mode
          </label>
          <select
            value={variantMode}
            onChange={(e) => onVariantModeChange(e.target.value)}
            className={selectClass}
            disabled={loading}
          >
            {VARIANT_MODE_OPTIONS.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <p className="text-xs text-gray-500">
        Stability (XYZ) is measured on the process-start timestamp of each case.
        The time step is derived automatically from how much data you have. The
        Object Matrix and Cross Matrix are configured inline in the tile.
      </p>
    </div>
  </div>
);

export default ABCXYZAnalysisSettings;
